import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Row, Col } from "reactstrap";
import FormCard from "../../Forms";
import StepperEvent from "../../../../../Components/StepperEvent";
import { openNotification } from "../../../../../Components/Notification";
import {
  ItemDetailResumeForm,
  ItemDetailResumeFormDates,
} from "../../../../template";

const ItemSummary = ({
  item,
  t,
  handleEditItem,
  index,
  update,
  isEdit,
  lng,
  disabledUpdate,
  FIELDS_WITHOUT_QUOTES,
}) => {
  const [poItem, setPoItem] = useState(item);
  const [poItemOriginal, setPoItemOriginal] = useState(item);
  const [errors, setErrors] = useState({});
  const [formDetailFields, setFormDetailFields] = useState({
    ...ItemDetailResumeForm,
  });
  const [formDetailDatesFields, setFormDetailDatesFields] = useState({
    ...ItemDetailResumeFormDates,
  });

  const hasRequiredValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  };

  useEffect(() => {
    setPoItem(item);
    setPoItemOriginal(item);
    setErrors({});
    validateEditableFields();
  }, [item]);

  const updateEntityInfo = (id, value) => {
    let newPoItem = { ...poItem };
    newPoItem[id] = value;
    setPoItem(newPoItem);

    if (id === "QTYOrdered" || id === "QTYConfirmed") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        QTYConfirmed: false,
      }));
      return;
    }

    if (errors[id]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: false,
      }));
    }
  };

  const getMissingRequiredItemFields = () =>
    ItemDetailResumeForm.edit
      .filter((field) => field.required && !hasRequiredValue(poItem[field.id]))
      .map((field) => t(field.label));

  const notifyMissingRequiredItemFields = (missingFields) => {
    openNotification(
      "error",
      `${t("resume.required.fields")}: ${missingFields.join(", ")}`
    );
  };

  const isQtyConfirmedGreaterThanOrdered = () => {
    if (!hasRequiredValue(poItem.QTYConfirmed)) return false;

    return Number(poItem.QTYConfirmed) > Number(poItem.QTYOrdered);
  };

  const notifyInvalidQtyConfirmed = () => {
    const message = t("resume.items.qtyconfirmed.greater.than.ordered")
    openNotification("error", message);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validateEditableFields = () => {
    console.log("validateEditableFields");
    const noEditableFields = [
      "QTYOrdered",
      // 'QTYConfirmed',
      "NetWeight",
      // 'RequestedExWorks',
      // 'RequiredCagoReady',
    ];
    let newFormDetailFields = { ...ItemDetailResumeForm };
    let newFormDetailDatesFields = { ...ItemDetailResumeFormDates };
    newFormDetailFields.edit = [];
    newFormDetailDatesFields.edit = [];
    ItemDetailResumeForm.edit.forEach((field) => {
      const copyField = { ...field };
      if (item.StatusId > 47 && noEditableFields.includes(field.id)) {
        copyField.type = "Label";
      }
      newFormDetailFields.edit.push(copyField);
    });
    ItemDetailResumeFormDates.edit.forEach((field) => {
      const copyField = { ...field };
      if (item.StatusId > 47 && noEditableFields.includes(field.id)) {
        copyField.type = "Label";
      }
      newFormDetailDatesFields.edit.push(copyField);
    });
    setFormDetailFields(newFormDetailFields);
    setFormDetailDatesFields(newFormDetailDatesFields);
  };

  const updateItem = async () => {
    const missingRequiredFields = getMissingRequiredItemFields();
    const isValid = missingRequiredFields.length === 0;

    if (!isValid) {
      notifyMissingRequiredItemFields(missingRequiredFields);
      return;
    }

    if (isQtyConfirmedGreaterThanOrdered()) {
      setErrors({
        QTYConfirmed: true,
      });
      notifyInvalidQtyConfirmed();
      return;
    }

    const sanitizedItem = sanitizeObjectWithoutQuotes(
      poItem,
      FIELDS_WITHOUT_QUOTES
    );
    await update(sanitizedItem);
    handleEditItem(index);
  };

  const sanitizeObjectWithoutQuotes = (data, fieldsWithoutQuotes) => {
    if (!data || !fieldsWithoutQuotes) return data;

    const sanitized = { ...data };

    Object.keys(sanitized).forEach((key) => {
      const isRestricted =
        (typeof fieldsWithoutQuotes.has === "function" &&
          fieldsWithoutQuotes.has(key)) ||
        (Array.isArray(fieldsWithoutQuotes) &&
          fieldsWithoutQuotes.includes(key));

      if (isRestricted && typeof sanitized[key] === "string") {
        sanitized[key] = sanitized[key].replace(/['"]/g, "");
      }
    });

    return sanitized;
  };

  const handleEdit = () => {
    setPoItem(poItemOriginal);
    handleEditItem(index, !Boolean(poItem.edit));
  };

  return (
    <div className="row">
      {isEdit && (
        <Row className="col-12">
          <Col xs={12} md={12} lg={12}>
            <button
              className="btn btn-primary float-right"
              style={{ marginBottom: "5px" }}
              onClick={updateItem}
              disabled={disabledUpdate}
            >
              {t("update")}
            </button>
            <button
              style={{ marginBottom: "5px", marginRight: "10px" }}
              className="btn btn-secondary float-right"
              onClick={handleEdit}
            >
              {t("cancel")}
            </button>
          </Col>
        </Row>
      )}
      <div className="col-12">
        <StepperEvent steps={poItem.Steps} />
      </div>
      <div className="col-12 row item-resume-form">
        <FormCard
          fields={formDetailFields}
          values={poItem}
          errors={errors}
          edit={isEdit}
          updateEntityInfo={updateEntityInfo}
          lng={lng}
          FIELDS_WITHOUT_QUOTES={FIELDS_WITHOUT_QUOTES}
        />
      </div>
      <div className="col-12 item-resume-date-title" style={{ paddingLeft: 0 }}>
        <div className="card-header">
          <div className="card-title" style={{ fontWeight: "bold" }}>
            {t(ItemDetailResumeFormDates.titulo)}
          </div>
        </div>
      </div>
      <div className="col-12 row">
        <FormCard
          fields={formDetailDatesFields}
          values={poItem}
          edit={isEdit}
          updateEntityInfo={updateEntityInfo}
          lng={lng}
        />
      </div>
    </div>
  );
};

export default withNamespaces()(withRouter(ItemSummary));
